import React, { useState } from 'react';
import { Box, Select, MenuItem, Button, Typography } from '@mui/material';

const ToggleList = ({ onConfirm }) => {
    const [selectedState, setSelectedState] = useState('');

    // List of German states in German
    const germanStates = [
        'Baden-Württemberg',
        'Bayern',
        'Berlin',
        'Brandenburg',
        'Bremen',
        'Hamburg',
        'Hessen',
        'Mecklenburg-Vorpommern',
        'Niedersachsen',
        'Nordrhein-Westfalen',
        'Rheinland-Pfalz',
        'Saarland',
        'Sachsen',
        'Sachsen-Anhalt',
        'Schleswig-Holstein',
        'Thüringen',
    ];

    const stateToIndex = {
        Brandenburg: 1,
        Berlin: 2,
        'Baden-Württemberg': 3,
        Bayern: 4,
        Bremen: 5,
        Hessen: 6,
        Hamburg: 7,
        'Mecklenburg-Vorpommern': 8,
        Niedersachsen: 9,
        'Nordrhein-Westfalen': 10,
        'Rheinland-Pfalz': 11,
        'Schleswig-Holstein': 12,
        Saarland: 13,
        Sachsen: 14,
        'Sachsen-Anhalt': 15,
        Thüringen: 16,
    };
    // Handles user confirmation
    // Here handleConfirm will pass the select Satet to parent via "onConfirm"
    const handleConfirm = () => {
        if (!selectedState) {
            alert('Bitte wählen Sie ein Bundesland aus.');
            return;
        }
        onConfirm(stateToIndex[selectedState]); // Pass the selected state to the parent for backend processing
    };

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Bitte wählen Sie ein Bundesland
            </Typography>
            <Select
                value={selectedState}
                onChange={(e) => setSelectedState(e.target.value)}
                fullWidth
            >
                {germanStates.map((state, index) => (
                    <MenuItem key={index} value={state}>
                        {state}
                    </MenuItem>
                ))}
            </Select>
            <Button
                variant="contained"
                sx={{ mt: 2 }}
                onClick={handleConfirm}
                fullWidth
            >
                Bestätigen
            </Button>
        </Box>
    );
};

export default ToggleList;
